import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const addColumnBeforeCommand = ({ editor, range }) =>
  range ? editor.chain().focus().deleteRange(range).addColumnBefore().run() : editor.chain().focus().addColumnBefore().run();

const AddColumnBefore = ({ editor, showLabel = false, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<ArrowLeftOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => addColumnBeforeCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="TABLE_ADD_COL_BEFORE" defaultMessage="Add column before" />
        </div>
      )}
    </Button>
  );
};

export default AddColumnBefore;
